import MatchTitle from "../items/MatchTitle";
import CustomText from "../CustomText";
import Currency from "../../config/Currency";
import MatchMyPickButtonContainer from "../cards/MatchMyPickButtonContainer";
import MatchHeaderDropdown, { MatchType } from "../MatchHeaderDropdown";
import Colors from "../../config/Colors";
import HowToPlayCarousel from "../carousel/HowToPlayCarousel";
import MatchCard from "../cards/MatchCard";
import {
  isMobile,
  mapAbbrToLogo,
  mapAbbrToLogoWithURL,
  stageType,
} from "../../types/type";
import moment from "moment";
import { UserCount } from "../../services";
import { useEffect, useState } from "react";
import { getCount } from "../../config/UserStorer";
import { formatNumber } from "../../pages/MainPage";
import Header from "../Header";
import { Oval } from "react-loader-spinner";
interface MatchProps {
  amount?: string;
  onPickClick?: () => void;
  onChooseMatch?: (match: any) => void;
  matches?: Array<MatchType>;
  onPlayed: (match: MatchType) => void;
  onLeaderBoard?: () => void;
  userCount: UserCount;
  onShare?: () => void;
  launchRegistration: (stagename: stageType) => void;
  trackItem: (name: string) => void;
  loader: { index: number; visible: boolean };
}

function MatchSegment({
  amount,
  onChooseMatch,
  onPickClick,
  matches,
  onPlayed,
  onLeaderBoard,
  userCount,
  onShare,
  launchRegistration,
  trackItem,
  loader,
}: MatchProps) {
  const [userC, setUserC] = useState(getCount());
  const handlePick = () => {
    if (onPickClick) {
      onPickClick();
    }
  };
  const loadCount = () => {
    console.log("userCD", getCount());
    setTimeout(() => {
      if (getCount() === null) loadCount();
      else setUserC(getCount());
    }, 1000);
  };
  useEffect(() => {
    if (JSON.stringify(userC) === JSON.stringify({ user_count: 0 })) {
      loadCount();
    }
    console.log("userC_", userC);
  }, [userC]);

  const handleChoose = (match: any) => {
    if (onChooseMatch) {
      onChooseMatch(match);
    }
  };

  const handleOnClick = () => {
    if (onLeaderBoard) {
      onLeaderBoard();
    }
  };

  const handleShare = () => {
    if (onShare) {
      onShare();
    }
  };

  return (
    <div className="relative flexColumn">
      <MatchTitle />
      <Header share={true} onShare={handleShare} />
      <MatchHeaderDropdown
        matches={matches}
        onChoose={handleChoose}
        amount={amount}
      />
      <div className="itemsCenter flexColumn pageMatchesListContainer ">
        <CustomText
          spacing={0}
          size="xlarge"
          weight="400"
          color={Colors.primary}
          marginBottom={20}
          marginTop={20}
        >
          CHOOSE A MATCH
        </CustomText>
        <div className="pageMatchesList">
          {matches?.length === 0 && (loader.index !== 0 || !loader.visible) && (
            <>
              <CustomText
                spacing={0}
                size="xsmall"
                weight="800"
                color={Colors.primary}
                marginBottom={20}
                marginTop={20}
                textAlign="center"
              >
                No Upcoming Matches Available.
              </CustomText>
            </>
          )}
          {(loader.index !== 0 || !loader.visible) &&
            matches &&
            matches?.map((match, index) => (
              <MatchCard
                key={index}
                marginBottom={30}
                marginLeft={20}
                marginRight={20}
                startTime={match?.start_time}
                team1Image={mapAbbrToLogoWithURL(match, false).logo}
                team2Image={mapAbbrToLogoWithURL(match, true)?.logo}
                team1Name={mapAbbrToLogoWithURL(match, false).name + ""}
                team2Name={mapAbbrToLogoWithURL(match, true).name + ""}
                isPlayed={match?.is_played}
                onClick={() => {
                  if (
                    moment(match.start_time + "Z").diff(
                      moment(),
                      "milliseconds"
                    ) < 0 ||
                    !match.is_played
                  ) {
                    handleChoose(match);
                  } else {
                    onPlayed(match);
                  }
                }}
              />
            ))}

          {loader.index === 0 && loader.visible && (
            <Oval
              height={30}
              width={30}
              color="orangered"
              wrapperStyle={{ justifyContent: "center" }}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="gray"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          )}
        </div>
        <MatchMyPickButtonContainer
          numberOfPeople={
            userCount.user_count === 0
              ? "____"
              : formatNumber(userCount.user_count) + ""
          }
          loader={loader}
          marginBottom={50}
          onClick={() => {
            if (localStorage.getItem("ajio_access_token") !== null) {
              handlePick();
            } else {
              trackItem("RegistrationLaunchedByMyPick");
              launchRegistration("MyPick");
            }
          }}
        />

        <div
          className="buttonCheckOutWeeklyLeaderBoard"
          onClick={() => {
            if (localStorage.getItem("ajio_access_token") !== null) {
              handleOnClick();
            } else {
              trackItem("RegistrationLaunchedByLeaderboard");
              launchRegistration("LeaderBoard");
            }
          }}
        >
          {loader.index === 2 && loader.visible === true && (
            <Oval
              height={30}
              width={30}
              color="orangered"
              wrapperStyle={{ justifyContent: "center" }}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="gray"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          )}
          {(loader.index !== 2 || !loader.visible) && (
            <CustomText
              textAlign="center"
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
              color={Colors.primary}
              size={isMobile ? "small" : "smallMedium"}
            >
              CHECK OUT THE LEADERBOARD
            </CustomText>
          )}
        </div>
      </div>
      <HowToPlayCarousel />
    </div>
  );
}

export default MatchSegment;
